import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { flexCenter, palette } from '../../constants/styles';
import { HEADER_HEIGHT } from '../GoalsFlow/styles';
import Icon from './Icon';
import Title from './Title';
import StepCounter from './StepCounter';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { WhiteLogo } from './resultsStyles';

// TODO: Poner pointer: cursor en botones de adelante y atrás

const StyledUpperHeader = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-self: center;
  align-self: center;
  height: 100%;
  width: 100%;
`;

const CustomFlowHeader = styled.div`
  ${flexCenter}
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  height: ${HEADER_HEIGHT}px;
  width: 100vw;
  padding-top: 5px;
  box-sizing: border-box;
  background-color: ${palette.primaryColor};
  z-index: 1000;
`;

export const StyledBackButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-decoration: underline;
  align-items: center;
  position: absolute;
  left: 2px;
  top: 2px;
  color: ${palette.sweetGray};
  font-size: 0.8em;
`;

const StyledTrialPlan = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  justify-self: flex-end;
  position: absolute;
  right: 2px;
  top: 2px;
  color: ${palette.sweetGray};
  font-size: 0.8em;
`;

const StyledReinforcement = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-self: center;
  align-items: center;
  color: ${palette.sweetGray};
  background-color: #333333;
  border-radius: 2px;
  padding: 10px 7px 2px 7px;
  font-size: 0.6em;
  margin-top: -18px;
`;

const StyledNav = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
`;

const FlowHeader = ({
  goBack,
  goForward,
  title,
  macroStep,
  numberOfSteps,
  hasBeenAnswered,
  previousTitle,
}) => (
  <CustomFlowHeader>
    <StyledUpperHeader>
      <StyledNav>
        {macroStep !== 1 && (
          <StyledBackButton
            onClick={() => {
              goBack();
            }}
          >
            <Icon
              icon="arrowBack"
              style={{ marginRight: '3px' }}
              color={palette.sweetGray}
              size={13}
            />
            {previousTitle}
          </StyledBackButton>
        )}
        <StyledReinforcement>
          <Icon icon="lock" style={{ marginRight: '3px' }} color={palette.sweetGray} size={8} />
          anónimo y gratuito
        </StyledReinforcement>
        {macroStep === 1 && (
          <StyledTrialPlan to="/plan/res/7314/preview">
            Plan de prueba
            <Icon icon="newtab" style={{ marginLeft: '3px' }} color={palette.sweetGray} size={13} />
          </StyledTrialPlan>
        )}
      </StyledNav>
      <div>
        {title === '' ? (
          <WhiteLogo src={FinautaWhiteLogo} id="logo" />
        ) : (
          <Title level={5} color="white" medium>
            {title}
          </Title>
        )}
      </div>
    </StyledUpperHeader>
    {/* <Text type="errorMessage" medium>Paso número {macroStep}</Text> */}
    <StepCounter currentStep={macroStep} numberOfSteps={numberOfSteps} />
  </CustomFlowHeader>
  //   <CustomFlowHeader>
  //   <StyledUpperHeader>
  //     { macroStep !== 1 && (
  //       <StyledBackButton onClick={goBack}>
  //         <Icon icon="arrowBack" style={{ marginRight: '5px' }} color={palette.sweetGray} size={25} />
  //           Regresar
  //       </StyledBackButton>
  //     )
  //     }
  //     {(title === '') ? (
  //       <WhiteLogo
  //         src={FinautaWhiteLogo}
  //         id="logo"
  //       />
  //     ) : <Title level={5} color="white" medium>{title}</Title>}
  //
  //   </StyledUpperHeader>
  //   {/* <Text type="errorMessage" medium>Paso número {macroStep}</Text> */}
  //   <StepCounter currentStep={macroStep} numberOfSteps={numberOfSteps} />
  // </CustomFlowHeader>
);

FlowHeader.propTypes = {
  macroStep: PropTypes.number,
  numberOfSteps: PropTypes.number,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  title: PropTypes.string,
  hasBeenAnswered: PropTypes.bool,
};

FlowHeader.defaultProps = {
  goBack: () => {},
  goForward: () => {},
  title: 'template title',
  macroStep: 1,
  numberOfSteps: 8,
  hasBeenAnswered: false,
};

export default FlowHeader;
